/**
 * A stable colour per subject.
 *
 * The API gives every subject a `color_hex`, and that is used when it is there.
 * When it is not — a custom subject a student typed in, an older row — the colour
 * is derived from the id rather than assigned in list order, so a subject keeps
 * the same colour after another is added or removed. A timetable whose colours
 * reshuffle when you add a class is worse than one with no colours at all.
 */

export const SUBJECT_COLOURS = [
  'var(--subject-1)',
  'var(--subject-2)',
  'var(--subject-3)',
  'var(--subject-4)',
  'var(--subject-5)',
  'var(--subject-6)',
  'var(--subject-7)',
  'var(--subject-8)',
] as const

export function subjectColour(id: string | null | undefined, explicit?: string | null): string {
  if (explicit) return explicit
  if (!id) return SUBJECT_COLOURS[7]

  // FNV-1a. Cheap, and stable across runs — `String.hashCode`-style sums collide
  // badly on ids that differ by one character, which uuids frequently do.
  let hash = 0x811c9dc5
  for (let i = 0; i < id.length; i += 1) {
    hash ^= id.charCodeAt(i)
    hash = Math.imul(hash, 0x01000193)
  }
  return SUBJECT_COLOURS[Math.abs(hash) % SUBJECT_COLOURS.length]!
}
